import { Token } from "inversify-token";
import { ReactiveMicrocomponent } from "yinzcam-rma";
import { YinzCamAPIRequestParameters } from "./YinzCamAPIRequestParameters";

export const YinzCamAPIRequestParameterComponentToken = new Token<YinzCamAPIRequestParameterComponent>(Symbol.for("YinzCamAPIRequestParameterComponent"));

export interface YinzCamAPIRequestParameterComponent<I extends YinzCamAPIRequestParameters[]=[]> 
  extends ReactiveMicrocomponent<YinzCamAPIRequestParameters> {
}
